export type RoleValues = 'ADMIN' | 'MENTEE' | 'MENTOR';

enum ROLES {
  ADMIN = 'Administrateur',
  MENTEE = 'Mentoré',
  MENTOR = 'Mentor',
}

export default ROLES;
